module.exports = __webpack_public_path__ + "974952b73567dc9b2becdad60d10635b.fbx";